export const menuPOS = [
  {
    titulo: 'Bloquear terminal',
    icon: 'lock',
    rota: '',
    nav: false,
    tela: false,
  },
  {
    titulo: 'Trocar de operador',
    icon: 'switch_accounts',
    rota: 'sessoes/logout',
    nav: false,
    tela: false,
  },
  {
    titulo: 'Trocar tela',
    icon: 'widgets',
    rota: '',
    nav: false,
    tela: true,
  },
  {
    titulo: 'Sair do POS',
    icon: 'undo',
    rota: '/dashboard',
    nav: true,
    tela: false,
  },
  {
    titulo: 'Sair',
    icon: 'logout',
    rota: 'sessoes/logout',
    nav: false,
    tela: false,
  }
]
